import Api from '../api';

const partyContactService = {
  async getPartyContacts(partyNumber) {
    const params = {
      'cross-company': true,
      $filter: `PartyNumber eq '${partyNumber}'`,
    };

    return Api.get('/data/PartyContactsV3', { params });
  },

  async postPartyContact(data) {
    const params = { 'cross-company': true };
    return Api.post('/data/PartyContactsV3', data, { params });
  },

  async patchPartyContact(partyNumber, electronicAddressId, data) {
    const params = { 'cross-company': true };
    const headers = { 'If-Match': '*' };
    return Api.patch(
      `/data/PartyContactsV3(PartyNumber='${partyNumber}',ElectronicAddressId='${electronicAddressId}')`,
      data,
      { params, headers }
    );
  },

  async deletePartyContact(partyNumber, electronicAddressId) {
    const params = { 'cross-company': true };
    const headers = { 'If-Match': '*' };
    return Api.delete(
      `/data/PartyContactsV3(PartyNumber='${partyNumber}',ElectronicAddressId='${electronicAddressId}')`,
      { params, headers }
    );
  },
};

export default partyContactService;
